import type { ReactNode } from "react";

interface RedoButtonProps {
  disabled: boolean;
  onRedo: () => void;
}

/** "Redo", beside Undo, on a row whose `can_redo` is true (requirements What 3). */
export function RedoButton({ disabled, onRedo }: RedoButtonProps): ReactNode {
  return (
    <button type="button" className="review-redo" onClick={onRedo} disabled={disabled}>
      Redo
    </button>
  );
}
